import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import TrackCard from "../../shared/TrackCard";

export default function TrackShipment() {
  const [code, setCode] = useState("");
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searched, setSearched] = useState("");

  const search = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setLoading(true);
    setError("");
    setResults(null);
    setSearched(code.trim());
    try {
      const res = await axios.get(`/api/track/${code.trim()}`);
      setResults(res.data);
    } catch (err) {
      setError(err.response?.data?.message || "Nothing found for that code.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="customer-page track-shipment-page">
      <div className="page-header customer-page-header">
        <Link to="/home" className="back-btn">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </Link>
        <div>
          <span className="customer-eyebrow">Live tracking</span>
          <h1>Track Shipment</h1>
          <p>Follow your cargo from warehouse to Ghana.</p>
        </div>
      </div>

      <div className="page-content track-content">
        <div className="track-intro">
          <span>TRACK A PACKAGE</span>
          <strong>Where is your shipment?</strong>
          <p>
            Enter a tracking number or shipping mark to see the latest movement.
          </p>
        </div>
        <form onSubmit={search} className="tk-search-form track-search-card">
          <input
            className="input-field"
            placeholder="Enter tracking code or shipping mark…"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <button
            type="submit"
            className="btn btn-primary tk-search-btn"
            disabled={loading}
          >
            {loading ? (
              <span className="spinner" />
            ) : (
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            )}
          </button>
        </form>

        {error && (
          <div className="empty-state">
            <div className="icon">🔍</div>
            <p style={{ fontWeight: 700, marginBottom: 6 }}>Nothing found</p>
            <p>
              No shipment matched <strong>"{searched}"</strong>. Check your
              tracking code or shipping mark and try again.
            </p>
          </div>
        )}

        {results && results.length === 0 && (
          <div className="empty-state">
            <div className="icon">📭</div>
            <p>No items found for that code.</p>
          </div>
        )}

        {results && (
          <div className="track-results-heading">
            <span>Shipment results</span>
            <strong>
              {results.length} {results.length === 1 ? "item" : "items"} found
            </strong>
          </div>
        )}
        {results && results.map((item, i) => <TrackCard key={i} item={item} />)}
      </div>
    </div>
  );
}
